import {Component, EventEmitter, OnInit} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

@Component({
  selector: 'app-editor-formly',
  templateUrl: './editor-formly.component.html',
  styleUrls: ['./editor-formly.component.scss']
})
export class EditorFormlyComponent extends FieldType implements OnInit {
  public label: string;
  public scope: 'backoffice' | 'dealer-system' = 'backoffice';
  public bupload: string;
  public toolsType: 'minimal' | 'normal' = 'normal';
  public extraTools = [];
  public required = false;
  public ngModel = '';
  public ngModelChange: EventEmitter<string> = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.field && this.field.templateOptions) {
      this.label = this.field.templateOptions.label;
      this.required = this.field.templateOptions.required;
      if (this.field.templateOptions.attributes) {
        this.extraTools = (<string>this.field.templateOptions.attributes.extraTools).split(',');
        this.scope = <'backoffice' | 'dealer-system'>this.field.templateOptions.attributes.scope;
        this.toolsType = <'minimal' | 'normal'>this.field.templateOptions.attributes.toolsType;
        this.bupload = <string>this.field.templateOptions.attributes.bupload;
      }
    }
    if (this.formControl) {
      this.ngModel = this.formControl.value ? this.formControl.value : [];
      this.ngModelChange.subscribe(v => {
        this.formControl.setValue(v);
      });
    }
  }

}
